import axios from "axios";
const ServiceURL = process.env.VUE_APP_SERVICEURL;

export default {
  name: "bebanCostCenter",
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getCostList(store) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: ServiceURL + "rekap_beban",
          params: {
            tlc: store.rootState.auth.auth.username
          },
          auth: {
            username: store.rootState.auth.auth.username,
            password: store.rootState.auth.auth.password
          },
          headers: {
            "X-API-KEY": store.rootState.auth.auth.apikey
          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getManifest(store, { id }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: ServiceURL + "rekap_beban",
          params: {
            id_manifest: id,
            tlc: store.rootState.auth.auth.username
          },
          auth: {
            username: store.rootState.auth.auth.username,
            password: store.rootState.auth.auth.password
          },
          headers: {
            "X-API-KEY": store.rootState.auth.auth.apikey
          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getMaster(store) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: ServiceURL + "rekap_beban/master",
          auth: {
            username: store.rootState.auth.auth.username,
            password: store.rootState.auth.auth.password
          },
          headers: {
            "X-API-KEY": store.rootState.auth.auth.apikey
          }
        })
          .then(response => {
            resolve(response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    createBeban(store, { data }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: ServiceURL + "rekap_beban",
          data: data,
          auth: {
            username: store.rootState.auth.auth.username,
            password: store.rootState.auth.auth.password
          },
          headers: {
            "X-API-KEY": store.rootState.auth.auth.apikey,
            "Content-Type": "multipart/form-data",
          }
        })
          .then(response => {
            resolve(response);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};
